import { Link } from "react-router-dom";
import { TYPE_LABELS } from "@/types/work";
import type { Work } from "@/types/work";

interface WorkCardProps {
  work: Work;
  index?: number;
}

export default function WorkCard({ work, index }: WorkCardProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 cursor-pointer"
      style={index !== undefined ? { animationDelay: `${index * 60}ms` } : undefined}
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={work.cover}
          alt={`${work.title} 封面`}
          title={`${work.title} ${TYPE_LABELS[work.type]} 剧情介绍`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 top-0 flex items-start justify-between p-2.5">
          <span className="rounded-md bg-accent-500/95 px-2 py-0.5 text-xs font-semibold text-accent-950">
            {work.rating.toFixed(1)}
          </span>
          <span className="rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-medium text-background-50 backdrop-blur-sm">
            {TYPE_LABELS[work.type]}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 to-transparent p-2.5 pt-8">
          <span className="text-xs font-medium text-accent-200">{work.status}</span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="clamp-1 truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
          {work.title}
        </h3>
        <p className="clamp-2 mt-1.5 text-xs leading-relaxed text-foreground-600">
          {work.shortIntro}
        </p>
        <div className="mt-3 flex flex-wrap items-center gap-1.5">
          {work.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              {genre}
            </span>
          ))}
          <span className="ml-auto shrink-0 text-[11px] text-foreground-500">
            {work.updatedAt}
          </span>
        </div>
      </div>
    </Link>
  );
}